// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_BuscaDespesaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /despesas/buscaDespesa/{despesa_id}
 *
 * Returns a single despesa record with datetime fields converted to ISO 8601 UTC.
 * The `dados` field is the despesa object with all its properties.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Despesas_BuscaDespesaResponseDados {
despesa_id?: number
despesa_titulo?: string
despesa_descricao?: string
despesa_franquia_id?: number
despesa_usuario_id?: number
despesa_usuario_alvo_id?: number
despesa_categoria_id?: number
despesa_data_lancamento?: string
despesa_data_vencimento?: string
despesa_tipo_mensal?: number
despesa_status?: number
despesa_parcela?: number
despesa_qtd_parcelas?: number
despesa_valor?: number
despesa_payroll_period_id?: number
despesa_generated_from_payroll?: number
despesa_generated_from_payroll_id?: number
plano_conta_id?: number
despesa_nota_fiscal?: string
}

export type Despesas_BuscaDespesaResponse = ApiResponse<Despesas_BuscaDespesaResponseDados>;

registerResponseContract('Despesas_BuscaDespesaResponse', {
  despesa_id:                        { type: 'number',  required: false },
  despesa_titulo:                    { type: 'string',  required: false },
  despesa_descricao:                 { type: 'string',  required: false },
  despesa_franquia_id:               { type: 'number',  required: false },
  despesa_usuario_id:                { type: 'number',  required: false },
  despesa_usuario_alvo_id:           { type: 'number',  required: false },
  despesa_categoria_id:              { type: 'number',  required: false },
  despesa_data_lancamento:           { type: 'string',  required: false },
  despesa_data_vencimento:           { type: 'string',  required: false },
  despesa_tipo_mensal:               { type: 'number',  required: false },
  despesa_status:                    { type: 'number',  required: false },
  despesa_parcela:                   { type: 'number',  required: false },
  despesa_qtd_parcelas:              { type: 'number',  required: false },
  despesa_valor:                     { type: 'number',  required: false },
  despesa_payroll_period_id:         { type: 'number',  required: false },
  despesa_generated_from_payroll:    { type: 'number',  required: false },
  despesa_generated_from_payroll_id: { type: 'number',  required: false },
  plano_conta_id:                    { type: 'number',  required: false },
  despesa_nota_fiscal:               { type: 'string',  required: false },
})
